import { AES, enc } from 'crypto-ts';

export const setEncryptedPayload = (message: string) => {
    const key = 'd2a8499b5be01fdc2f607500a88d742d686dbc846a14e312ba6c323b2870502f5fc643188f80c1215bd99971425aee64f88080e50bb6b0b7ce749d9aef761ab8';//process.env.REACT_APP_COMMUNICATION?.toString();
    return key ? encodeURIComponent(AES.encrypt(message, key).toString()) : message;
}

export const getDecryptedResponse = (message: string) => {
    const key = 'd2a8499b5be01fdc2f607500a88d742d686dbc846a14e312ba6c323b2870502f5fc643188f80c1215bd99971425aee64f88080e50bb6b0b7ce749d9aef761ab8';//process.env.REACT_APP_COMMUNICATION?.toString();
    const bytes = key ? AES.decrypt(decodeURIComponent(message), key) : message;
    return JSON.parse(bytes.toString(enc.Utf8));
}

export const encryptoPlatform = (message: string, platformKey: string) => {
    return encodeURIComponent(AES.encrypt(message, platformKey).toString());
}

export const decryptoPlatform = (message: string, platformKey: string) => {
    const bytes = AES.decrypt(decodeURIComponent(message), platformKey);
    return bytes.toString(enc.Utf8);
}